import { Box, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC } from 'react';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import { Company } from '@apiContract';

import { sxList, sxNoResult } from '../styles';
import Item from './Item';

type Props = {
  loadNextPage: (startIndex: number, stopIndex: number) => void | Promise<void>;
  isNextPageLoading: boolean;
  items: Array<Company>;
  setSelectedItem: (company: Company) => void;
  selectedItem?: Company;
  hasNextPage: boolean;
};

const CompanyItem = ({ style, index, data }: ListChildComponentProps) => (
  <Item
    style={style}
    selected={!!data.selectedItem && !!data.items[index] && data.items[index]?.id === data.selectedItem?.id}
    item={data.items[index]}
    handleClick={() => data.items[index] && data.setSelectedItem(data.items[index] as Company)}
  />
);

const CompanyList: FC<Props> = ({
  loadNextPage,
  isNextPageLoading,
  items,
  setSelectedItem,
  selectedItem,
  hasNextPage,
}) => {
  const theme = useTheme();
  const isSmallHeight = useMediaQuery('(max-height: 500px)');

  const itemCount = hasNextPage ? items.length + 1 : items.length;
  const loadMoreItems = isNextPageLoading ? () => {} : loadNextPage;
  const isItemLoaded = (index: number) => !hasNextPage || index < items.length;

  return (
    <Box sx={{ ...sxList(theme) }}>
      <InfiniteLoader isItemLoaded={isItemLoaded} itemCount={itemCount} loadMoreItems={loadMoreItems}>
        {({ onItemsRendered, ref }) => {
          return (
            <FixedSizeList
              height={isSmallHeight ? 200 : 315}
              width={368}
              onItemsRendered={onItemsRendered}
              itemCount={itemCount}
              itemSize={66}
              ref={ref}
              itemData={{
                selectedItem,
                items,
                setSelectedItem,
                isNextPageLoading,
              }}
              className="companiesScrollBar"
            >
              {CompanyItem}
            </FixedSizeList>
          );
        }}
      </InfiniteLoader>
      {items.length === 0 && !isNextPageLoading ? (
        <Typography sx={sxNoResult} variant="body2">
          No results found
        </Typography>
      ) : null}
    </Box>
  );
};

export default CompanyList;
